<script setup>
import { ref, computed } from "vue";

const props = defineProps({
    text: {
        type: String,
        default: "",
    },
});

const showFullText = ref(false);

const displayedText = computed(() => {
    if (!showFullText.value && props.text) {
        if (props.text.length > 200) {
            return `${props.text.slice(0, 200)}...`;
        }
        return props.text.slice(0, 200);
    } else {
        return props.text;
    }
});

const readMoreText = computed(() => (showFullText.value ? "less" : "more"));
</script>

<template>
    <div class="">
        <div class="pb-2">
            <span>{{ displayedText }}</span>
        </div>
        <a
            v-if="text && text.length > 200"
            class="mt-1 pt-0 text-blue-600 hover:text-blue-700 font-semibold text-sm cursor-pointer"
            style="white-space: normal"
            @click="showFullText = !showFullText"
        >
            read {{ readMoreText }}
        </a>
    </div>
</template>
